import React from 'react'
import { useTranslate } from 'react-admin'
import { Box, Chip } from '@mui/material'
import 'src/assets/donutStylesAnimation.css'
import { userServices } from 'src/services/reservation/user/user.service'
import { useQuery } from 'react-query'

export const ExchangeTypeCard = () => {
  const currenciesByUser = useQuery('currencies', userServices.getCurrencyByUser)
  const translate = useTranslate()
  const labelExchangeType = (currency) => {
    if (currency) {
      return `${currency.currency_relation.symbol} ${currency.currency_relation.short_name} - ${currency.currency_to_relation.symbol} ${currency.currency_to_relation.short_name} : ${currency.value}`
    }
    return translate('ra.message.no_data')
  }

  return (
    <Box
      position={'relative'}
      display={'flex'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      width={'100%'}
      height={'100px'}
    >
      {currenciesByUser.isLoading &&
        [...Array(4)].map((_, key) => (
          <Chip
            key={key}
            label={translate('ra.action.loading')}
            variant='outlined'
            style={{
              margin: '0px 5px 0px 5px',
              backgroundColor: '#8FBC8F',
              fontSize: 'medium',
              fontWeight: 'bold',
            }}
          />
        ))}

      {(currenciesByUser.data || [])
        .filter((currency) => !currency.is_reverse)
        .map((currency, key) => (
          <Chip
            key={key}
            label={labelExchangeType(currency)}
            variant='outlined'
            style={{
              margin: '0px 5px 0px 5px',
              backgroundColor: '#8FBC8F',
              fontSize: 'medium', // Aumentar el tamaño del texto
              fontWeight: 'bold', // Hacer el texto más grueso
            }}
          />
        ))}
    </Box>
  )
}
